/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { Form, Table } from 'react-bootstrap';
import GetAdminConfiguration from '../../api/GetAdminConfig';
import UserDefinedLabels from '../../utils/UserDefinedLabels';
import './Registrationsetup.scss';

const RecoveryFields = (props) => {
  const { iIndex, fields } = props;
  const [stateFields, setStateFields] = useState({});
  const { CertificateNumberLabel, AlternateID1Label, AlternateID2Label } =
    UserDefinedLabels();

  const {
    resetFirstName,
    resetLastName,
    resetDateOfBirth,
    resetSSN,
    resetMemberID,
    resetAlternateID1,
    resetAlternateID2,
    resetMedicareID,
    resetPostalCode,
    resetRelationship,
    resetAlternateEmail,
    resetPhoneNumber,
    resetAllowRecoveryUsingAltMail,
  } = stateFields;

  const handleChange = (event) => {
    setStateFields({
      ...stateFields,
      [event.target.name]: event.target.checked,
    });
  };

  const handleOptionChange = (event) => {
    setStateFields({ ...stateFields, [event.target.name]: event.target.value });
  };

  useEffect(() => {
    setStateFields({
      ...stateFields,
      resetOid: fields.OID,
      resetRecordType: fields.RecordType,
      resetAllowRecoveryUsingAltMail:
        fields.AllowRecoveryUsingAltMail === 'YES' ? true : false,
      resetFirstName: fields.FirstName === 'Visible' ? true : false,
      resetLastName: fields.LastName === 'Visible' ? true : false,
      resetDateOfBirth: fields.DateOfBirth === 'Visible' ? true : false,
      resetPostalCode: fields.PostalCode === 'Visible' ? true : false,
      resetRelationship: fields.Relationship === 'Visible' ? true : false,
      resetPhoneNumber: fields.PhoneNumber === 'Visible' ? true : false,
      resetSSN: fields.SocialSecurityNumber === 'Visible' ? true : false,
      resetMemberID: fields.CertificateNumber === 'Visible' ? true : false,
      resetCertificateNumber:
        fields.CertificateNumber === 'Visible' ? true : false,
      resetAlternateID1: fields.AlternateID1 === 'Visible' ? true : false,
      resetAlternateID2: fields.AlternateID2 === 'Visible' ? true : false,
      resetMedicareID: fields.MedicareID === 'Visible' ? true : false,
      resetAlternateEmail: fields.Email === 'Visible' ? true : false,
    });
  }, [fields]);

  useEffect(() => {
    console.log(iIndex, stateFields.resetFirstName);
    GetAdminConfiguration.resetFirstName[iIndex] =
      stateFields.resetFirstName === true ? 'Visible' : 'Invisible';
  }, [iIndex, stateFields.resetFirstName]);

  useEffect(() => {
    console.log(iIndex, stateFields.resetLastName);
    GetAdminConfiguration.resetLastName[iIndex] =
      stateFields.resetLastName === true ? 'Visible' : 'Invisible';
  }, [iIndex, stateFields.resetLastName]);

  useEffect(() => {
    console.log(iIndex, stateFields.resetDateOfBirth);
    GetAdminConfiguration.resetDateOfBirth[iIndex] =
      stateFields.resetDateOfBirth === true ? 'Visible' : 'Invisible';
  }, [iIndex, stateFields.resetDateOfBirth]);

  useEffect(() => {
    console.log(iIndex, stateFields.resetSSN);
    GetAdminConfiguration.resetSSN[iIndex] =
      stateFields.resetSSN === true ? 'Visible' : 'Invisible';
  }, [iIndex, stateFields.resetSSN]);

  useEffect(() => {
    console.log(iIndex, stateFields.resetMemberID);
    GetAdminConfiguration.resetMemberID[iIndex] =
      stateFields.resetMemberID === true ? 'Visible' : 'Invisible';
  }, [iIndex, stateFields.resetMemberID]);

  useEffect(() => {
    console.log(iIndex, stateFields.resetAlternateID1);
    GetAdminConfiguration.resetAlternateID1[iIndex] =
      stateFields.resetAlternateID1 === true ? 'Visible' : 'Invisible';
  }, [iIndex, stateFields.resetAlternateID1]);

  useEffect(() => {
    console.log(iIndex, stateFields.resetAlternateID2);
    GetAdminConfiguration.resetAlternateID2[iIndex] =
      stateFields.resetAlternateID2 === true ? 'Visible' : 'Invisible';
  }, [iIndex, stateFields.resetAlternateID2]);

  useEffect(() => {
    console.log(iIndex, stateFields.resetMedicareID);
    GetAdminConfiguration.resetMedicareID[iIndex] =
      stateFields.resetMedicareID === true ? 'Visible' : 'Invisible';
  }, [iIndex, stateFields.resetMedicareID]);

  useEffect(() => {
    console.log(iIndex, stateFields.resetPostalCode);
    GetAdminConfiguration.resetPostalCode[iIndex] =
      stateFields.resetPostalCode === true ? 'Visible' : 'Invisible';
  }, [iIndex, stateFields.resetPostalCode]);

  useEffect(() => {
    console.log(iIndex, stateFields.resetRelationship);
    GetAdminConfiguration.resetRelationship[iIndex] =
      stateFields.resetRelationship === true ? 'Visible' : 'Invisible';
  }, [iIndex, stateFields.resetRelationship]);

  useEffect(() => {
    console.log(iIndex, stateFields.resetAlternateEmail);
    GetAdminConfiguration.resetAlternateEmail[iIndex] =
      stateFields.resetAlternateEmail === true ? 'Visible' : 'Invisible';
  }, [iIndex, stateFields.resetAlternateEmail]);

  useEffect(() => {
    console.log(iIndex, stateFields.resetPhoneNumber);
    GetAdminConfiguration.resetPhoneNumber[iIndex] =
      stateFields.resetPhoneNumber === true ? 'Visible' : 'Invisible';
  }, [iIndex, stateFields.resetPhoneNumber]);

  return (
    <div>
      <Table striped bordered hover className="m-0">
        <thead>
          <tr>
            <th style={{ textAlign: 'center' }}>Publish</th>
            <th style={{ textAlign: 'center' }}>Field</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <Form.Group id="formGridresetFirstName">
                <Form.Label className="sr-only" for="resetFirstName">
                  firstname
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={resetFirstName}
                  onChange={handleChange}
                  id="resetFirstName"
                  name="resetFirstName"
                />
              </Form.Group>
            </td>
            <td>First Name</td>
          </tr>
          <tr>
            <td>
              <Form.Group id="formGridresetLastName">
                <Form.Label className="sr-only" for="resetLastName">
                  resetLastName
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={resetLastName}
                  onChange={handleChange}
                  id="resetLastName"
                  name="resetLastName"
                />
              </Form.Group>
            </td>
            <td>Last Name</td>
          </tr>
          <tr>
            <td>
              <Form.Group id="formGridresetDateOfBirth">
                <Form.Label className="sr-only" for="DateOfBirth">
                  DateOfBirth
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={resetDateOfBirth}
                  onChange={handleChange}
                  id="DateOfBirth"
                  name="resetDateOfBirth"
                />
              </Form.Group>
            </td>
            <td>Date of Birth</td>
          </tr>
          <tr>
            <td>
              <Form.Group id="formGridCheckbox1">
                <Form.Label className="sr-only" for="resetSSN">
                  resetSSN
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={resetSSN}
                  onChange={handleChange}
                  id="resetSSN"
                  name="resetSSN"
                />
              </Form.Group>
            </td>
            <td>SSN</td>
          </tr>
          <tr>
            <td>
              <Form.Group id="formGridCheckbox1">
                <Form.Label className="sr-only" for="resetMemberID">
                  resetMemberID
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={resetMemberID}
                  onChange={handleChange}
                  id="resetMemberID"
                  name="resetMemberID"
                />
              </Form.Group>
            </td>
            <td>{CertificateNumberLabel}</td>
          </tr>
          <tr>
            <td>
              <Form.Group id="formGridCheckbox1">
                <Form.Label className="sr-only" for="resetAlternateID1">
                  resetAlternateID1
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={resetAlternateID1}
                  onChange={handleChange}
                  id="resetAlternateID1"
                  name="resetAlternateID1"
                />
              </Form.Group>
            </td>
            <td>{AlternateID1Label}</td>
          </tr>
          <tr>
            <td>
              <Form.Group id="formGridCheckbox1">
                <Form.Label className="sr-only" for="resetAlternateID2">
                  resetAlternateID2
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={resetAlternateID2}
                  id="resetAlternateID2"
                  onChange={handleChange}
                  name="resetAlternateID2"
                />
              </Form.Group>
            </td>
            <td>{AlternateID2Label}</td>
          </tr>
          <tr>
            <td>
              <Form.Group id="formGridCheckbox1">
                <Form.Label className="sr-only" for="resetMedicareID">
                  resetMedicareID
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={resetMedicareID}
                  onChange={handleChange}
                  id="resetMedicareID"
                  name="resetMedicareID"
                />
              </Form.Group>
            </td>
            <td>Medicare ID</td>
          </tr>
          <tr>
            <td>
              <Form.Group id="formGridCheckbox1">
                <Form.Label className="sr-only" for="resetPostalCode">
                  resetPostalCode
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={resetPostalCode}
                  onChange={handleChange}
                  id="resetPostalCode"
                  name="resetPostalCode"
                />
              </Form.Group>
            </td>
            <td>Postal Code</td>
          </tr>
          <tr>
            <td>
              <Form.Group id="formGridCheckbox1">
                <Form.Label className="sr-only" for="resetRelationship">
                  resetRelationship
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={resetRelationship}
                  onChange={handleChange}
                  id="resetRelationship"
                  name="resetRelationship"
                />
              </Form.Group>
            </td>
            <td>Relationship</td>
          </tr>
          <tr>
            <td>
              <Form.Group id="formGridCheckbox1">
                <Form.Label className="sr-only" for="resetAlternateEmail">
                  resetAlternateEmail
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={resetAlternateEmail}
                  onChange={handleChange}
                  id="resetAlternateEmail"
                  name="resetAlternateEmail"
                />
              </Form.Group>
            </td>
            <td>Alternate Email</td>
          </tr>
          <tr>
            <td>
              <Form.Group id="formGridCheckbox1">
                <Form.Label className="sr-only" for="resetPhoneNumber">
                  resetPhoneNumber
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={resetPhoneNumber}
                  onChange={handleChange}
                  id="resetPhoneNumber"
                  name="resetPhoneNumber"
                />
              </Form.Group>
            </td>
            <td>Phone Number</td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default RecoveryFields;
